<template>
  <div
    class="flex flex-col sm:flex-wrap md:flex-row gap-3 bg-opacity-90"
    :class="{
      'bg-untitled-gray-50': !isKintz,
    }"
  >
    <div
      class="flex justify-center items-center p-2 border md:shadow-lg rounded-md cursor-pointer drop-shadow-sm gap-2"
      :class="{
        'bg-white border-untitled-gray-200 text-untitled-gray-60': !isKintz,
          'bg-kintz-primary-1 text-kintz-primary-2':
            selectedMainTab === 'featured' && isKintz,
          'bg-kintz-primary-3 text-kintz-primary-4':
            selectedMainTab !== 'featured' && isKintz,
          'hover:bg-kintz-primary-1 hover:text-kintz-primary-2': isKintz,
      }"
      @click="handleClickTab('featured')"
      v-if="selectedMainTab !== 'featured'"
    >
      <el-tooltip
        :content="wrapTooltipContent('Show All Featured Contents')"
        effect="dark"
        :raw-content="true"
        placement="bottom"
      >
        <HomeIcon class="w-7 hidden md:block" />
      </el-tooltip>
      <p
        class="text-xs 0 font-semibold uppercase text-center md:hidden"
      >
        Featured Content
      </p>
    </div>
    <div
      class="p-2 sm:p-3 rounded-md shadow flex-1 flex justify-center items-center cursor-pointer"
      @click="handleClickTab('enrolled')"
      :class="[
        {
          'bg-untitled-gray-200 text-untitled-gray-600':
            selectedMainTab === 'enrolled' && !isKintz,
          'bg-white text-untitled-gray-600':
            selectedMainTab !== 'enrolled' && !isKintz,
          'hover:bg-untitled-gray-100': !isKintz,
          'bg-kintz-primary-1 text-kintz-primary-2':
            selectedMainTab === 'enrolled' && isKintz,
          'bg-kintz-primary-3 text-kintz-primary-4':
            selectedMainTab !== 'enrolled' && isKintz,
          'hover:bg-kintz-primary-1 hover:text-kintz-primary-2': isKintz,
        },
      ]"
    >
      <p class="text-xs font-semibold uppercase text-center">
        {{ tabName }}
      </p>
    </div>
    <div
      class="p-2 sm:p-3 rounded-md shadow flex-1 flex justify-center items-center cursor-pointer"
      @click="handleClickTab('playlist')"
      :class="[
        {
          'bg-untitled-gray-200 text-untitled-gray-600':
            selectedMainTab === 'playlist' && !isKintz,
          'bg-white text-untitled-gray-600':
            selectedMainTab !== 'playlist' && !isKintz,
          'hover:bg-untitled-gray-100': !isKintz,
          'bg-kintz-primary-1 text-kintz-primary-2':
            selectedMainTab === 'playlist' && isKintz,
          'bg-kintz-primary-3 text-kintz-primary-4':
            selectedMainTab !== 'playlist' && isKintz,
          'hover:bg-kintz-primary-1 hover:text-kintz-primary-2': isKintz,
        },
      ]"
    >
      <p class="text-xs font-semibold uppercase text-center">
        {{ userName }} Learning Path & Playlists
      </p>
    </div>
    <div
      class="p-2 sm:p-3 rounded-md shadow flex-1 flex justify-center items-center cursor-pointer"
      @click="handleClickTab('content')"
      :class="[
        {
          'bg-untitled-gray-200 text-untitled-gray-600':
            selectedMainTab === 'content' && !isKintz,
          'bg-white text-untitled-gray-600':
            selectedMainTab !== 'content' && !isKintz,
          'hover:bg-untitled-gray-100': !isKintz,
          'bg-kintz-primary-1 text-kintz-primary-2':
            selectedMainTab === 'content' && isKintz,
          'bg-kintz-primary-3 text-kintz-primary-4':
            selectedMainTab !== 'content' && isKintz,
          'hover:bg-kintz-primary-1 hover:text-kintz-primary-2': isKintz,
        },
      ]"
    >
      <p class="text-xs font-semibold uppercase text-center">
        {{ isKintz ? 'Categories' : 'All Available Content' }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { useAuthStore } from "@/stores";
import { useHomeCoursesStore } from "@/stores/home/useHomeCourses.store";
import { useHomeTabsStore } from "@/stores/home/useHomeTabs.store";
import { useEnrolledCourseStore } from "@/stores/enrolledCourseStore";
import { storeToRefs } from "pinia";
import { computed, defineProps } from "vue";
import { HomeIcon } from "@heroicons/vue/solid";
import { ElTooltip } from "element-plus";
import { wrapTooltipContent } from "@/composable/wrapTooltipContent";

const props = defineProps({
  isKintz: {
    type: Boolean,
    default: false,
  },
});

const authStore = useAuthStore();
const homeCoursesStore = useHomeCoursesStore();
const homeTabStore = useHomeTabsStore();
const enrolledCourseStore = useEnrolledCourseStore();

const { selectedMainTab } = storeToRefs(homeTabStore);

const tabName = computed(() => homeCoursesStore.homeTab);
const userName = computed(() => authStore.fullName);
const isKintz = computed(() => props.isKintz);

const handleClickTab = (tabName) => {
  selectedMainTab.value = tabName;
  if (tabName === 'enrolled') {
    enrolledCourseStore.selectedFilter = {
      ...enrolledCourseStore.selectedFilter,
      available_course: false,
      enrolled_course: true,
    };
  } else if (tabName === 'content') {
    enrolledCourseStore.selectedFilter = {
      ...enrolledCourseStore.selectedFilter,
      available_course: true,
      enrolled_course: false,
    };
  }

  window.scrollTo({ top: 0, behavior: "smooth" });
};
</script>

<style lang="scss" scoped></style>
